import { compress, decompress } from "lz-string";
import { errorLogger } from "../logger";
import { IOEM } from "@/Common/interfaces/location";

const storageRemoveItem = (key: string): void => {
	try {
		const compressedKey = compress(key);
		window.localStorage.removeItem(compressedKey);
	} catch (error) {
		errorLogger(error as Error, { function: "storageRemoveItem", message: `Error removing ${key} from localStorage`, key });
	}
};

const storageSetItem = (key: string, data: unknown): void => {
	try {
		const compressedKey = compress(key);
		const compressedData = compress(JSON.stringify(data));
		window.localStorage.setItem(compressedKey, compressedData);
	} catch (error) {
		errorLogger(error as Error, { function: "storageSetItem", message: `Error setting ${key} from localStorage`, key });
	}
};

const storageGetItem = (key: string): unknown => {
	const compressedKey = compress(key);
	const decompressedData = decompress(window.localStorage.getItem(compressedKey) ?? "");
	try {
		if (decompressedData) {
			return JSON.parse(decompressedData);
		}
	} catch (error) {
		errorLogger(error as Error, { function: "storageGetItem", message: `Error getting ${key} from localStorage`, key });
	}
	return null;
};

const getOemState = (state: IOEM[]) => {
	return state.map((oem) => {
		return {
			oemReference: oem.oemReference,
			legalName: oem.legalName,
			oemName: oem.oemName ?? "",
			version: oem.version ?? "",
			financialStatementVersion: oem.financialStatementVersion ?? "",
			dealerCodeFS: oem.dealerCodeFS ?? "",
			dba: oem.dba ?? "",
			franchises: oem.franchises?.map((franchise) => {
				return {
					franchise: franchise.franchise,
					dealerCode: franchise.dealerCode,
					groups: franchise.groups ?? [],
					isCombined: franchise.isCombined ?? false,
					area: typeof franchise.area === "string" ? JSON.parse(franchise.area) : franchise.area,
				};
			}),
		};
	});
};

export { storageSetItem, storageGetItem, getOemState, storageRemoveItem };
